<ng-container *ngIf="uploadFrom === 'uploadShipment'">
  <div class="row">
    <div class="col-11 text-start">
      <h4>
        {{ 'mapping.upload.uploadShipments' | translate }}
      </h4>
    </div>

    <div class="col-1 text-center icon-mat-close">
      <i mat-dialog-close class="bi bi-x"></i>
    </div>
  </div>

  <mat-dialog-content>
    <div class="row">
      <div class="col-3 text-center">
        <label class="pt-2 required-field">
          {{ 'mapping.upload.specification' | translate }}
        </label>
      </div>

      <div class="text-center col-3">
        <mat-select
          class="form-control"
          placeholder="{{ 'mapping.upload.selectSpecification' | translate }}"
          [(ngModel)]="selectedSpec"
          (selectionChange)="specChangeEvent()">
          <mat-option [value]="">
            {{ 'mapping.upload.selectSpecification' | translate }}
          </mat-option>
          <mat-option *ngFor="let spec of specList" [value]="spec">
            {{ spec.specifications_id }}
          </mat-option>
        </mat-select>
      </div>

      <div class="text-end col-6">
        <input
          type="file"
          #fileInput
          (change)="onFileChange($event, fileInput)"
          accept="text/plain, .csv" />
      </div>
    </div>
  </mat-dialog-content>

  <div class="mt-3 msg text-center" *ngIf="showStatus">
    {{ selectedFileName }} {{ 'mapping.upload.fileUploadSuccess' | translate }}
  </div>

  <div class="col-12 mt-3">
    <app-shipment-upload-status></app-shipment-upload-status>
  </div>

  <mat-dialog-actions align="end">
    <button class="primary-btn" (click)="uploadShipmentData(fileInput)">
      {{ 'mapping.upload.upload' | translate }}
    </button>
  </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="uploadFrom === 'uploadLineItem'">
  <div class="row">
    <div class="col-11 text-start">
      <h4 class="mb-2">
        {{ 'mapping.upload.uploadItemDetails' | translate }}
      </h4>
    </div>

    <div class="col-1 text-center icon-mat-close">
      <i mat-dialog-close class="bi bi-x floating-button"></i>
    </div>
  </div>
  <mat-dialog-content>
    <div class="row">
      <div class="col-3">
        <label class="pt-2 required-field">
          {{ 'mapping.upload.specification' | translate }}
        </label>
      </div>

      <div class="col-3">
        <mat-select
          class="form-control"
          placeholder="{{ 'mapping.upload.selectSpecification' | translate }}"
          [(ngModel)]="selectedLineItemSpec"
          (selectionChange)="lineItemSpecChangeEvent()">
          <mat-option [value]="">
            {{ 'mapping.upload.selectSpecification' | translate }}
          </mat-option>
          <mat-option
            *ngFor="let specification of invoiceSpecificationList"
            [value]="specification">
            {{ specification?.specifications_id }}
          </mat-option>
        </mat-select>
      </div>

      <div class="col-6 text-center">
        <input
          type="file"
          #fileInput
          (change)="onLinItemUploadFileChange($event, fileInput)"
          accept="text/plain, .csv" />
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button class="primary-btn floating-button mt2" (click)="uploadLineItemsContent()">
      {{ 'mapping.upload.upload' | translate }}
    </button>
  </mat-dialog-actions>

  <div>
    <app-shipment-upload-status
      [isUploadStatus]="'invoice'"
      [mawbNumber]="mawb"></app-shipment-upload-status>
  </div>
</ng-container>

<ng-container *ngIf="uploadFrom === 'uploadInvoice'">
  <div class="row">
    <div class="col-11 text-start">
      <h4 class="mb-2">
        {{
          motherStatus !== 'Closed'
            ? ('mapping.upload.uploadDocuments' | translate)
            : ('mapping.upload.viewDocuments' | translate)
        }}
      </h4>
    </div>
    <div class="col-1 text-center icon-mat-close">
      <i mat-dialog-close class="bi bi-x"></i>
    </div>
  </div>

  <mat-dialog-content>
    <div class="row">
      <ng-container *ngIf="motherStatus !== 'Closed'">
        <div class="col-3">
          <label class="pt-2 required-field">
            {{ 'mapping.upload.documentType' | translate }}
          </label>
        </div>

        <div class="col-3">
          <mat-select
            class="form-control"
            placeholder="{{ 'mapping.upload.selectDocumentType' | translate }}"
            (selectionChange)="invoiceSpecChangeEvent($event)">
            <mat-option [value]="">
              {{ 'mapping.upload.selectDocumentType' | translate }}
            </mat-option>
            <mat-option *ngFor="let type of typeCode" [value]="type?.code">
              {{ type.value }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-6 text-center">
          <input
            type="file"
            #fileInput
            (change)="onInvoiceUploadFileChange($event, fileInput)"
            accept=".jpeg,.jpg,.gif,.tiff,.png,.pdf"
            multiple />
          <label class="upload-notice"
            >* Only JPEG,PNG,GIF,TIFF and PDF can be uploaded and must be with the same file
            extension.</label
          >
        </div>
      </ng-container>

      <div class="col-12">
        <app-shipment-upload-status
          [motherStatus]="motherStatus"
          [isUploadStatus]="'typeCode'"
          [mawbNumber]="mawb"
          [ShipmentIdNumber]="shipmentID"></app-shipment-upload-status>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button *ngIf="motherStatus !== 'Closed'" class="primary-btn" (click)="uploadInvoiceContent()">
      {{ 'mapping.upload.upload' | translate }}
    </button>
  </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="uploadFrom === 'uploadAddress'">
  <div class="row">
    <div class="col-11 text-start">
      <h4 class="mb-2">
        {{
          motherStatus !== 'Closed'
            ? ('mapping.upload.uploadDocuments' | translate)
            : ('mapping.upload.viewDocuments' | translate)
        }}
      </h4>
    </div>
    <div class="col-1 text-center icon-mat-close">
      <i mat-dialog-close class="bi bi-x"></i>
    </div>
  </div>
  <mat-dialog-content>
    <div class="row">
      <ng-container *ngIf="motherStatus !== 'Closed'">
        <div class="col-3">
          <label class="pt-2 required-field">
            {{ 'mapping.upload.addressType' | translate }}
          </label>
        </div>
        <div class="col-3">
          <mat-select
            class="form-control"
            placeholder="{{ 'mapping.upload.selectAddressType' | translate }}"
            (selectionChange)="addressTypeChangeEvent($event)">
            <mat-option [value]="">
              {{ 'mapping.upload.selectAddressType' | translate }}
            </mat-option>
            <mat-option *ngFor="let type of addressType" [value]="type">
              {{ type }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-6 text-center">
          <input
            type="file"
            #fileInput
            (change)="onAddressUploadFileChange($event, fileInput)"
            accept=".csv" />
        </div>
      </ng-container>

      <div class="col-12">
        <app-shipment-upload-status
          [motherStatus]="motherStatus"
          [isUploadStatus]="'address'"
          [mawbNumber]="mawb">
        </app-shipment-upload-status>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button *ngIf="motherStatus !== 'Closed'" class="primary-btn" (click)="uploadAddressContent()">
      {{ 'mapping.upload.upload' | translate }}
    </button>
  </mat-dialog-actions>
</ng-container>

<ng-template #confirmDialog>
  <mat-dialog-content>
    <div class="row">
      <div class="col-12">
        <h6 class="text-center">
          {{ 'mapping.upload.documentTypeFileExist' | translate }}
        </h6>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button class="primary-btn" (click)="closeDialog()">
      {{ 'global.cancel' | translate }}
    </button>
    <button class="secondary-btn ms-1" (click)="replace()">
      {{ 'global.yes' | translate }}
    </button>
  </mat-dialog-actions>
</ng-template>
